<template>
<div v-if="address !== null">
	<v-layout>
		<v-flex md3>
			<text-item :label="$t('address.country')" :text="address.country" />
		</v-flex>
		<v-flex md3>
			<text-item :label="$t('address.district')" :text="address.district" />
		</v-flex>
		<v-flex md3>
			<text-item :label="$t('address.region')" :text="address.region" />
		</v-flex>
		<v-flex md3>
			<text-item :label="$t('address.city')" :text="address.city" />
		</v-flex>
	</v-layout>

	<v-layout>
		<v-flex md3>
			<text-item :label="$t('address.index')" :text="String(address.index)" />
		</v-flex>
		<v-flex md3>
			<text-item :label="$t('address.smirovaci')" :text="address.smirovaci" />
		</v-flex>
		<v-flex md3>
			<text-item :label="$t('address.street')" :text="address.street" />
		</v-flex>
		<v-flex md3>
			<text-item :label="$t('address.building_number')" :text="address.building_number" />
		</v-flex>
	</v-layout>
</div>
</template>

<script>
import TextItem from './TextItem'
export default {
	components: {
		TextItem
	},
	props: {
		address: {
			type: Object,
			default: null
		}
	}
}
</script>
